import { defineStore } from "pinia";

export const useBayModeStore = defineStore("bayMode", {
  state: () => ({
    isActive: false,
    areaId: null as string | null,
  }),
  actions: {
    activate(areaId: string) {
      this.isActive = true;
      this.areaId = areaId;
      console.log('bayMode:', this.isActive, this.areaId)
    },
  },
  persist: true,
});
